if (!customElements.get('back-to-top')) {
  class BackToTop extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';

      this.button = this.querySelector('.layout-back-to-top__button');
      if (!this.button) return;

      if (this.hasDedicatedBackToTop()) {
        this.hidden = true;
        return;
      }

      this.updateTicking = false;
      this.onClick = () => this.scrollToTop();
      this.onViewportChange = () => this.requestUpdate();

      this.button.addEventListener('click', this.onClick);
      window.addEventListener('scroll', this.onViewportChange, { passive: true });
      window.addEventListener('resize', this.onViewportChange);
      document.addEventListener('shopify:section:load', this.onViewportChange);

      this.update();
    }

    disconnectedCallback() {
      if (!this.button || this.hidden) return;

      this.button.removeEventListener('click', this.onClick);
      window.removeEventListener('scroll', this.onViewportChange);
      window.removeEventListener('resize', this.onViewportChange);
      document.removeEventListener('shopify:section:load', this.onViewportChange);
    }

    hasDedicatedBackToTop() {
      if (document.querySelector('[data-bulk-back-to-top]')) return true;

      const productControl = document.querySelector('.pdp-sticky-menu__back-to-top');
      const productMenu = document.querySelector('product-sticky-menu');

      return Boolean(productControl && productMenu && !productMenu.hidden);
    }

    requestUpdate() {
      if (this.updateTicking) return;
      this.updateTicking = true;

      window.requestAnimationFrame(() => {
        this.updateTicking = false;
        this.update();
      });
    }

    update() {
      const shouldShow = window.scrollY > this.visibilityThreshold();

      this.style.setProperty('--layout-back-to-top-bottom', `${this.collisionSafeBottom()}px`);
      this.classList.toggle('is-visible', shouldShow);
      this.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      this.button.tabIndex = shouldShow ? 0 : -1;
    }

    visibilityThreshold() {
      return window.matchMedia('(max-width: 767px)').matches ? 700 : 1000;
    }

    collisionSafeBottom() {
      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      const baseOffset = isMobile ? 88 : 96;
      const buttonSize = isMobile ? 42 : 46;
      const rightInset = isMobile ? 16 : 24;
      const buttonLeft = window.innerWidth - rightInset - buttonSize;
      const buttonRight = window.innerWidth - rightInset;
      let offset = baseOffset;

      BackToTop.collisionSelectors.forEach((selector) => {
        document.querySelectorAll(selector).forEach((element) => {
          const style = window.getComputedStyle(element);
          if (
            style.position !== 'fixed' ||
            style.display === 'none' ||
            style.visibility === 'hidden' ||
            Number(style.opacity) === 0
          ) return;

          const rect = element.getBoundingClientRect();
          const touchesViewportBottom = rect.bottom >= window.innerHeight - 2 && rect.top < window.innerHeight;
          const overlapsButtonColumn = rect.right > buttonLeft && rect.left < buttonRight;

          if (touchesViewportBottom && overlapsButtonColumn) {
            offset = Math.max(offset, window.innerHeight - rect.top + 16);
          }
        });
      });

      return Math.min(offset, Math.max(baseOffset, window.innerHeight - buttonSize - 16));
    }

    scrollToTop() {
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      window.scrollTo({
        top: 0,
        behavior: prefersReducedMotion ? 'auto' : 'smooth'
      });
    }
  }

  BackToTop.collisionSelectors = [
    '[data-volume-discount-global]:not([hidden])',
    '.article__pagination.is-visible',
    '.sticky-atc-panel:not(.sticky-atc-panel--out)',
    '.labor-day-deals__bottom-bar',
    '.world-cup-progress.is-visible',
    '.btn--compare:not(.is-out):not(.is-open)'
  ];

  customElements.define('back-to-top', BackToTop);
}
